import { Map } from 'immutable';
import FacetType from "../records/FacetType";
export default Map({
  product: FacetType.disjunctive('version.compatibilities.applicationKey'),
  hidden: FacetType.disjunctive('hidden'),
  hosting: FacetType.disjunctive('version.compatibilities.hosting'),
  deployments: FacetType.disjunctive('deployments'),
  categories: FacetType.disjunctive('categories'),
  paid: FacetType.conjunctive('version.paid'),
  topVendor: FacetType.conjunctive('vendor.isTopVendor'),
  vendorSupported: FacetType.conjunctive('version.supported'),
  stable: FacetType.conjunctive('version.stable'),
  canonicalVersion: FacetType.conjunctive('version.canonicalVersion'),
  latestOfHosting: FacetType.conjunctive('version.latestOfHosting'),
  isAtlassian: FacetType.conjunctive('vendor.isAtlassian'),
  marketplaceType: FacetType.disjunctive('version.marketplaceType'),
  marketingLabels: FacetType.disjunctive('marketingLabels'),
  pluginSystemVersion: FacetType.conjunctive('version.pluginSystemVersion'),
  cloudFortified: FacetType.conjunctive('programs.cloudFortified.status'),
  freeStarterTier: FacetType.conjunctive('freeStarterTierStatus'),
  bugBountyParticipant: FacetType.conjunctive('programs.bugBountyParticipant')
});